export default "__VITE_ASSET__07330aab__"